// Aguarda o DOM estar completamente carregado
document.addEventListener('DOMContentLoaded', function() {
  // Função para inicializar o menu hover
  function initializeHoverMenu() {
    // Seleciona o menu inline (desktop)
    const headerInlineMenu = document.querySelector(".header__inline-menu");
    
    if (!headerInlineMenu) {
      console.log('Menu inline não encontrado');
      return;
    }

    // Seleciona todos os elementos details dentro do menu
    const menuItems = headerInlineMenu.querySelectorAll("details");
    
    if (menuItems.length === 0) {
      console.log('Nenhum item de menu encontrado');
      return;
    }

    console.log(`Encontrados ${menuItems.length} itens de menu`);

    // Para cada item do menu
    for (const menuItem of menuItems) {
      let hoverTimeout;
      let isHovering = false;

      // Função para abrir o menu
      function openMenu() {
        clearTimeout(hoverTimeout);
        isHovering = true;
        menuItem.setAttribute("open", true);
      }

      // Função para fechar o menu com delay
      function closeMenu() {
        isHovering = false;
        hoverTimeout = setTimeout(() => {
          if (!isHovering) {
            menuItem.removeAttribute("open");
          }
        }, 500); // Aumentado para 500ms - meio segundo
      }

      // Evento de mouseenter no summary (trigger do menu)
      const summary = menuItem.querySelector('summary');
      if (summary) {
        summary.addEventListener("mouseenter", openMenu);
        summary.addEventListener("mouseleave", closeMenu);
      }

      // Evento de mouseenter/mouseleave no submenu
      const submenu = menuItem.querySelector("ul");
      if (submenu) {
        submenu.addEventListener("mouseenter", openMenu);
        submenu.addEventListener("mouseleave", closeMenu);
      }

      // Evento de mouseenter/mouseleave no próprio details
      menuItem.addEventListener("mouseenter", openMenu);
      menuItem.addEventListener("mouseleave", closeMenu);

      // Previne o comportamento padrão de click no summary para desktop
      const summaryElement = menuItem.querySelector('summary');
      if (summaryElement) {
        summaryElement.addEventListener('click', function(e) {
          // Só previne o click em desktop (telas maiores que 990px)
          if (window.innerWidth >= 990) {
            e.preventDefault();
          }
        });
      }

      // Adiciona eventos para links dentro do submenu
      const submenuLinks = menuItem.querySelectorAll('ul a');
      submenuLinks.forEach(link => {
        link.addEventListener('mouseenter', openMenu);
      });
    }
  }

  // Inicializa o menu
  initializeHoverMenu();

  // Reinicializa se a tela for redimensionada
  window.addEventListener('resize', function() {
    // Pequeno delay para evitar múltiplas execuções
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(initializeHoverMenu, 250);
  });

  // Reinicializa se houver mudanças no DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Delay para evitar múltiplas execuções
        clearTimeout(window.mutationTimeout);
        window.mutationTimeout = setTimeout(initializeHoverMenu, 100);
      }
    });
  });

  // Observa mudanças no header
  const header = document.querySelector('header');
  if (header) {
    observer.observe(header, {
      childList: true,
      subtree: true
    });
  }
});
